import type { FC } from 'react';

import { H1 } from '@smartshell/ui-kit';
import cn from 'classnames';

import { ISettingsBlockProps } from './interfaces';
import s from './SettingsBlock.module.scss';

export const SettingsBlock: FC<ISettingsBlockProps> = ({
  title,
  children,
  small,
}) => {
  return (
    <div className={cn(s.container, small && s.container_small)}>
      <H1>{title}</H1>
      <div className={s.children_block}>{children}</div>
    </div>
  );
};
